// vMix-output: /gfx viser alle grafikker, /gfx/<id> kun én. Tilføj ?auto for
// at lade grafikken være på hele tiden og spille ind når siden indlæses
// (så kan inputtet styres med vMix' egne overlay-knapper).

import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import type { GfxGraphicId } from "@mma/shared";
import { GRAPHIC_BY_ID } from "../gfx/graphics.js";
import { GfxScreen } from "../gfx/Screen.js";
import { useGfxStream, useServerNow } from "../gfx/useGfx.js";

const W = 1920;
const H = 1080;

// Gennemsigtig baggrund i stedet for appens mørke tema.
function useTransparentPage() {
  useEffect(() => {
    const html = document.documentElement;
    const prev = { htmlClass: html.className, bodyClass: document.body.className };
    html.className = "";
    document.body.className = "";
    html.style.background = document.body.style.background = "transparent";
    return () => {
      html.className = prev.htmlClass;
      document.body.className = prev.bodyClass;
      html.style.background = document.body.style.background = "";
    };
  }, []);
}

function useFitScale() {
  const [scale, setScale] = useState(() => Math.min(window.innerWidth / W, window.innerHeight / H));
  useEffect(() => {
    const onResize = () => setScale(Math.min(window.innerWidth / W, window.innerHeight / H));
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  return scale;
}

export function GfxOutputPage() {
  useTransparentPage();
  const { id } = useParams();
  const [params] = useSearchParams();
  const { snapshot, offset } = useGfxStream();
  const now = useServerNow(offset);
  const scale = useFitScale();

  if (id && !(id in GRAPHIC_BY_ID)) return <div style={{ color: "white", padding: 40 }}>Ukendt grafik: {id}</div>;
  if (!snapshot) return null;
  return (
    <div style={{ position: "fixed", inset: 0, overflow: "hidden" }}>
      <div style={{ position: "absolute", width: W, height: H, transform: `scale(${scale})`, transformOrigin: "0 0" }}>
        <GfxScreen
          snapshot={snapshot}
          now={now}
          only={id ? [id as GfxGraphicId] : undefined}
          auto={params.has("auto")}
        />
      </div>
    </div>
  );
}
